export default class Scroll {

    constructor(mv) {

        this.$mv = mv.$mv;

        this._init();

    }

    _init() {

        this._addClick();

    }

    _addClick() {

        const $link = this.$mv.querySelector('.mv__btn a');

        $link.addEventListener('click', this._setScroll);

    }

    _setScroll(e) {

        e.preventDefault();

        const $target = document.querySelector(e.currentTarget.hash),
            rectTop = $target.getBoundingClientRect().top,
            gap = MAIN.isNarrow ? 43 : 0;

        window.scroll({
            behavior: 'smooth',
            top: rectTop + window.scrollY - gap,
        });

    }

}